module.exports = __webpack_public_path__ + "img/avatar-placeholder-male.09549103.png";